<div class="bg-off-white px-48px pt-24px pb-36px">
	<div class="flex justify-between mb-24px">
		<div></div>
		<h1 class="text-font-24 text-dark-grey">
			{{ 'STORE.UPDATE_STATUS_POPUP.HISTORY_STATUS' | translate }}
		</h1>
		<div (click)="closeDialog()">
			<img
				class="ml-[100%] cursor-pointer"
				src="assets/images/close-square.svg"
				alt=""
			/>
		</div>
	</div>
	<div class="mt-4 border-[1px] border-secondry-color-Gray rounded-[12px]">
		<div *ngFor="let item of historyData; let indx = index">
			<div class="flex justify-between px-[16px] py-[8px] h-[72px]">
				<div class="flex">
					<img
						[src]="statusHistoryImage(item?.orderStatus)"
						alt=""
						class="inline-block cursor-pointer ltr:mr-1 rtl:ml-1 h-[24px] w-[24px] my-auto"
					/>
					<div
						class="text-font-16 leading-[22px] text-dark-grey py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
					>
						{{ item?.date | date : 'dd/MM/yyyy' : 'UTC' }}
						<p class="text-font-14 text-medium-gray">
							{{ item?.date | date : 'hh:mm a' : 'UTC' }}
						</p>
						<p class="text-font-14 text-medium-gray">
							{{ item?.reason }}
						</p>
					</div>
				</div>
				<div class="my-auto">
					{{ item?.status }}
					<app-status
						[enumData]="orderStatus"
						[statusValue]="item?.orderStatus"
					>
					</app-status>
				</div>
			</div>
			<div
				*ngIf="indx + 1 != historyData?.length"
				class="w-full h-[1px] bg-secondry-color-Gray"
			></div>
		</div>
	</div>

	<div class="mt-24px">
		<button
			(click)="closeDialog()"
			class="w-full bg-gradient text-off-white py-[15px] rounded-6px mb-[10px] border-none"
		>
			{{ 'GENERAL_LABELS.DONE' | translate }}
		</button>
	</div>
</div>
